/* ===========================================================
   EVM · Portada
   Fundido entre imágenes, rayitas que se llenan y pausa
   cuando la portada no está a la vista.
   =========================================================== */

/* Con dos instancias de la sección en la misma página, el navegador
   ejecuta este archivo dos veces: si ya está definido, no se repite
   nada (ni la clase ni los listeners de documento). */
if (!customElements.get('evm-hero')) {

class EvmHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.evm-hero__slide'));
    if (!this.slides.length) return;

    this.ticks = Array.from(this.querySelectorAll('.evm-hero__tick'));
    this.index = 0;
    this.timer = null;
    this.paused = false;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.ticks.forEach((tick) => {
      tick.addEventListener('click', () => {
        this.show(parseInt(tick.dataset.index, 10));
        this.restart();
      });
    });

    this.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (!this.contains(document.activeElement)) return;
      e.preventDefault();
      this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1));
      this.restart();
      const tick = this.ticks[this.index];
      if (tick) tick.focus();
    });

    ['pointerenter', 'focusin'].forEach((e) =>
      this.addEventListener(e, () => { this.paused = true; })
    );
    ['pointerleave', 'focusout'].forEach((e) =>
      this.addEventListener(e, () => { this.paused = false; })
    );

    // Si la portada no se ve, no tiene sentido seguir pasando imágenes
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        ([entry]) => { this.visible = entry.isIntersecting; },
        { threshold: 0.15 }
      );
      this.observer.observe(this);
    } else {
      this.visible = true;
    }

    if (this.canAutoplay()) this.start();
  }

  disconnectedCallback() {
    this.stop();
    if (this.observer) this.observer.disconnect();
  }

  canAutoplay() {
    return this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduceMotion;
  }

  show(i) {
    const total = this.slides.length;
    const next = ((i % total) + total) % total;
    this.index = next;

    this.slides.forEach((slide, n) => {
      const on = n === next;
      slide.classList.toggle('is-active', on);
      if (on) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    this.ticks.forEach((tick, n) => {
      const on = n === next;
      tick.setAttribute('aria-selected', on ? 'true' : 'false');
      // Reiniciar la animación de llenado de la rayita activa
      const fill = tick.querySelector('.evm-hero__tick-fill');
      tick.classList.remove('is-active');
      if (fill) void fill.offsetWidth;
      if (on) tick.classList.add('is-active');
    });
  }

  start() {
    this.stop();
    const secs = parseInt(this.dataset.speed, 10) || 7;
    this.timer = window.setInterval(() => {
      if (this.paused || this.visible === false) return;
      this.show(this.index + 1);
    }, secs * 1000);
  }

  restart() {
    if (this.canAutoplay()) this.start();
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  revealBlock(blockId) {
    const slide = this.querySelector(`[data-shopify-editor-block*="${blockId}"]`);
    if (!slide) return;
    this.stop();
    this.show(this.slides.indexOf(slide));
  }
}

if (!customElements.get('evm-hero')) {
  customElements.define('evm-hero', EvmHero);
}

/* ---------- Editor de temas ---------- */
document.addEventListener('shopify:block:select', (event) => {
  const host = event.target.closest('evm-hero');
  if (host && typeof host.revealBlock === 'function') host.revealBlock(event.detail.blockId);
});

document.addEventListener('shopify:block:deselect', (event) => {
  const host = event.target.closest('evm-hero');
  if (host && typeof host.restart === 'function') host.restart();
});

}
